module.exports = __webpack_public_path__ + "static/media/20ECE25.cc87d89b.jpg";